import React from 'react';
import Sidebar from '../components/admin/Sidebar';

const AdminLayout = () => {
  return (
    <div className="flex h-screen">
      <Sidebar />
      <main className="flex-1 p-4 overflow-y-auto">
        <h1 className="text-2xl font-bold mb-4">Bienvenue dans l’admin</h1>
        {/* Tu peux ici rendre les routes enfants plus tard */}
      </main>
    </div>
  );
};

export default AdminLayout;
